module.exports = __webpack_public_path__ + "img/b2-3.dad3168.png";